import React from 'react';

import AssignmentCategoryScreen from './AssignmentCategoryScreen';

function AssignmentCategoryMainScreen() {
  
    return (
      <div className="App">       
        
        <AssignmentCategoryScreen />
       </div>
    );
   
}

export default AssignmentCategoryMainScreen;
